import React from 'react';

import { Typography } from '@mui/material';
import { Locale, useLocaleState } from 'contexts/locale/locale-context';

import { useIntl } from 'react-intl';
import RadioSelectItem from '../../../components/radio-select-item';
import Select from '../../../components/select';

type ChangeLocaleProps = {
  dark?: boolean;
  fullWidth?: boolean;
};

const ChangeLocale: React.FC<ChangeLocaleProps> = ({ dark = false, fullWidth = false }) => {
  const { locale, changeLocale } = useLocaleState();
  const intl = useIntl();

  return (
    <Select
      dark={dark}
      fullWidth={fullWidth}
      label={intl.formatMessage({ id: 'general.locale' })}
      value={locale}
      onChange={(event) => {
        changeLocale(event.target.value as Locale);
      }}>
      <RadioSelectItem value={'en-gb'} selected={locale === 'en-gb'}>
        <Typography fontSize={16}>English</Typography>
      </RadioSelectItem>
      <RadioSelectItem value={'nb'} selected={locale === 'nb'}>
        <Typography fontSize={16}>Norsk</Typography>
      </RadioSelectItem>
      <RadioSelectItem value={'es-cl'} selected={locale === 'es-cl'}>
        <Typography fontSize={16}>Español</Typography>
      </RadioSelectItem>
      <RadioSelectItem value={'vn'} selected={locale === 'vn'}>
        <Typography fontSize={16}>Tiếng việt</Typography>
      </RadioSelectItem>
    </Select>
  );
};

export default ChangeLocale;
